/**
 * Put your z-indices here - this makes it easier to understand
 * the overlapping behavior of different components on different pages
 * without having to z-hack your way to push your element to the top by picking
 * arbitrary numbers.
 */
export const Z_INDICES = {
  APP_NAV_HEADER: 100,
  INSTITUTION_PAGE_HEADER: 99,
  INSTITUTION_PAGE_STICKY_TABS: 98,
  DISCOVER_FEED_INTEREST_FLYOUT: 99,
};
